import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {DispatchVehicleResults} from "../../models/DispatchVehicleResults";
import {ErrorCodes} from "../../constants/ErrorCodes";
import {OnHoldUploadResults} from "../../models/OnHoldUploadResults";

@Component({
  selector: 'app-popup-file-upload-message-dialog',
  templateUrl: './popup-file-upload-message-dialog.component.html',
  styleUrls: ['./popup-file-upload-message-dialog.component.scss']
})

/**
 * This is a shared component for displaying the error message from file upload feature in Dispatch screen and On Hold screen.
 * This dialog should only display if there is warning or error occurs during file uploading. Successful upload should show the regular 'success notification toast'.
 * - The error messages for On Hold and Dispatch screens contain up to 100 VINs that has error, and this component provide a scrollable pop-up dialog to ensures no text overflow.
 */
export class PopupFileUploadMessageDialogComponent implements OnInit {
  protected readonly SCREEN = SCREEN;

  dispatchResults: DispatchVehicleResults;
  header: string;
  canceledLabel: string = 'Nro Remito Cancelado';
  combinationNotFoundLabel: string = 'Vin-Nro combinacion no existe'; // used in dispatch upload
  vinNotFoundLabel: string = 'Vin no existe'; // used in on hold upload
  futureDispatchLabel: string = 'Fecha futura';
  existingDispatchLabel: string = 'Nueva fecha de despacho';
  releaseOnHoldErrorLabel: string = 'Release Error';


  futureDispatchText: string = ErrorCodes.DISPATCH_FUTURE_DATE;
  existingDispatchText: string = ErrorCodes.DISPATCH_EXISTING_DATE;

  onHoldResults: OnHoldUploadResults;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData ) {
  }

  ngOnInit(): void {
    if (this.data.type === SCREEN.dispatch) {
      this.dispatchResults = this.data.results;
      // Show 'file processed with warning' header.
      if (this.successfulWithWarningNoError()) {
        this.header = `${ErrorCodes.FILE_UPLOAD_SUCCESS} con advertencia`;
      } else {
        // Show partial error if there's successful dispatch, otherwise show no success.
        this.header = this.dispatchResults.fullyError ? ErrorCodes.FILE_UPLOAD_NO_SUCCESS : ErrorCodes.FILE_UPLOAD_PROCESSED_PARTIALLY;
      }
    }
    else if (this.data.type == SCREEN.onHold) { // On hold screen response return HttpErrorResponse instead of a result object like dispatch screen.
      this.onHoldResults = this.data.results;
      // Reuse error code from dispatch upload.
      this.header = this.onHoldResults.fullyError ? ErrorCodes.FILE_UPLOAD_NO_SUCCESS : ErrorCodes.FILE_UPLOAD_PROCESSED_PARTIALLY;
    }
  }

  successfulWithWarningNoError() : boolean {
    return (this.dispatchResults.notFoundRemitoList.length === 0 && this.dispatchResults.canceledRemitoList.length === 0)
    && (this.dispatchResults.existingDispatchDateList.length > 0 || this.dispatchResults.futureDispatchList.length > 0);
  }

  hasError(): boolean {
    return this.dispatchResults.notFoundRemitoList.length > 0 || this.dispatchResults.canceledRemitoList.length > 0
  }
}

export enum SCREEN {
  dispatch,
  onHold,
}

/**
 * @property type {@link SCREEN}
 * @property results The object returned when an error occurs.
 */
export interface DialogData {
  type: SCREEN,
  results: any
}
